import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";

function SearchSelect(props) {
  const {
    isOptionEqualToValue,
    getOptionLabel,
    noOptionsText,
    onInputChange,
    getOptionKey,
    renderOption,
    helperText,
    limitTags,
    multiple,
    disabled,
    onChange,
    options,
    loading,
    onClose,
    onOpen,
    value,
    error,
    open,
    max,
  } = props;

  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e, v) => {
    if (multiple) {
      if (v.length <= max) {
        onChange(v);
      }
    } else {
      onChange(v);
    }

    onClose();
  };

  const handleInputChange = (e, v) => {
    if (isFocused) {
      if (v) {
        onOpen();
        if (onInputChange) {
          onInputChange(e, v);
        }
      } else {
        onClose();
      }
    }
  };

  return (
    <Autocomplete
      isOptionEqualToValue={isOptionEqualToValue}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onInputChange={handleInputChange}
      filterSelectedOptions={multiple}
      getOptionLabel={getOptionLabel}
      noOptionsText={noOptionsText}
      getOptionKey={getOptionKey}
      renderOption={renderOption}
      onChange={handleChange}
      sx={{ width: "100%" }}
      selectOnFocus={false}
      limitTags={limitTags}
      disabled={disabled}
      multiple={multiple}
      loading={loading}
      options={options}
      value={value}
      size="small"
      open={open}
      renderInput={(params) => (
        <TextField
          {...params}
          helperText={helperText}
          error={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : null,
          }}
        />
      )}
    />
  );
}

SearchSelect.propTypes = {
  isOptionEqualToValue: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  noOptionsText: PropTypes.string,
  getOptionLabel: PropTypes.func,
  onInputChange: PropTypes.func,
  getOptionKey: PropTypes.func,
  renderOption: PropTypes.func,
  helperText: PropTypes.string,
  limitTags: PropTypes.number,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  max: PropTypes.number,
  value: PropTypes.any,
  open: PropTypes.bool,
};

export default SearchSelect;
